import { spawn, all } from "redux-saga/effects";
import authSagas from "./auth.sagas";
import userSagas from "./user.sagas";
import generalSagas from "./general.sagas";
import projectSagas from "./projects.sagas";
import clientSagas from "./clients.sagas";
import meetingSagas from "./meeting.sagas";
import scopeSagas from "./scope.sagas";
import portfolioSagas from "./portfolio.sagas";
import programSagas from "./programs.sagas";
import budgetSagas from "./budgets.sagas";
import changeRequestSagas from "./changeRequests.sagas";
import communicationSagas from "./communications.sagas";
import allocatedResourcesSagas from "./allocatedResources.sagas";
import risksSagas from "./risks.sagas";
import shiftsSagas from "./shifts.sagas";
import purchaseOrdersSagas from "./purchaseOrders.sagas";
import invoiceRegistrySagas from "./invoiceRegistry.sagas";
import decisionLogSagas from "./decisionLog.sagas";
import milestoneSagas from "./milestone.sagas";

export default function* rootSaga() {
  yield all([
    spawn(authSagas),
    spawn(userSagas),
    spawn(generalSagas),
    spawn(projectSagas),
    spawn(clientSagas),
    spawn(meetingSagas),
    spawn(scopeSagas),
    spawn(portfolioSagas),
    spawn(programSagas),
    spawn(budgetSagas),
    spawn(changeRequestSagas),
    spawn(communicationSagas),
    spawn(allocatedResourcesSagas),
    spawn(risksSagas),
    spawn(shiftsSagas),
    spawn(purchaseOrdersSagas),
    spawn(invoiceRegistrySagas),
    spawn(decisionLogSagas),
    spawn(milestoneSagas),
  ]);
}
